// © Microsoft Corporation. All rights reserved.

import { IconHandledProps as BaseHandledProps, IconProps as BaseIconProps, IconManagedClasses, IconUnhandledProps } from "./Icon.props";
import { Glyph, GlyphInline, GlyphType } from "./Icon.props";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";

import { Icon as BaseIcon } from "./Icon";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { IconCssClasses as IconClassNameContract } from "./Icon.styles";
import { IconStyles } from "./Icon.styles";
import { Subtract } from "utility-types";

const Icon = manageJss(IconStyles)(BaseIcon);
type Icon = InstanceType<typeof Icon>;
type IconHandledProps = Subtract<BaseHandledProps, IconManagedClasses>;
type IconProps = ManagedJSSProps<BaseIconProps, IconManagedClasses, DesignSystem>;

export {
    Icon,
    IconProps,
    IconClassNameContract,
    IconHandledProps,
    IconUnhandledProps,
    GlyphType,
    Glyph,
    GlyphInline
};